var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ centralized: true, 'remove-id-wall-loader': _vm.unmounted },attrs:{"data-testid":"id-wall"}},[(!_vm.isError)?_c('div',_vm._b({},"div",_vm._d({},[_vm.idWallAttribute,true]))):_vm._e(),(_vm.isError)?_c('GenericError',{on:{"on-retry":_vm.handleRetry}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }